export const FilterKey = {
  year: 'year',
  facility: 'facility',
  scope: 'scope',
  subFilters: 'subFilters'
};
export const FilterLabel = {
  year: 'Year',
  facility: 'Facility',
  scope: 'Scope',
  subFilters: 'Sub Filters'
};

export const ScopeOptions = [
  {
    value: 'scope1',
    label: 'Scope 1'
  },
  {
    value: 'scope2',
    label: 'Scope 2'
  },
  {
    value: 'scope3',
    label: 'Scope 3',
    checkValid: true
  }
];

export const ModuleConstants = {
  machine: 'machine',
  vehicle: 'vehicle',
  refrigerant: 'refrigerant',
  electricity: 'electricity',
  water: 'water',
  waste: 'waste',
  capitalgoods: 'capitalgoods',
  upstreamTransportation: 'upstreamTransportation',
  downstreamTransportation: 'downstreamTransportation',
  employeeCommute: 'employeeCommute',
  businessTravel: 'businessTravel',
  capitalGoodsAverage: 'capitalGoodsAverage',
  rawMaterialAverage: 'rawMaterialAverage',
  processingOfSoldProductsAverage: 'processingOfSoldProductsAverage'
};

export const SubFiltersOptions = [
  {
    value: ModuleConstants.machine,
    label: 'By Machine',
    scope: 'scope1'
  },
  {
    value: ModuleConstants.vehicle,
    label: 'By Vehicle',
    scope: 'scope1'
  },
  {
    value: ModuleConstants.refrigerant,
    label: 'By Refrigerant',
    scope: 'scope1'
  },
  {
    value: ModuleConstants.electricity,
    label: 'Electricity',
    scope: 'scope2'
  },
  {
    value: ModuleConstants.waste,
    label: 'Waste',
    scope: 'scope3'
  },
  {
    value: ModuleConstants.upstreamTransportation,
    label: 'Upstream Transportation',
    scope: 'scope3'
  },
  {
    value: ModuleConstants.downstreamTransportation,
    label: 'Downstream Transportation',
    scope: 'scope3'
  },
  {
    value: ModuleConstants.employeeCommute,
    label: 'Employee Commute',
    scope: 'scope3'
  },
  {
    value: ModuleConstants.businessTravel,
    label: 'Business Travel',
    scope: 'scope3'
  },
  {
    value: ModuleConstants.capitalGoodsAverage,
    label: 'Capital Goods- Average',
    scope: 'scope3'
  }
];

export const toDecimalString = (num: number, maxDecimals = 20): string => {
  if (num === 0) return '0';

  let str = num.toString();

  // Handle exponential notation
  if (str.includes('e')) {
    const [baseStr, expStr] = str.split('e');
    const exp = parseInt(expStr, 10);

    const [integerPart, fractionalPart = ''] = baseStr.split('.');
    const digits = (integerPart + fractionalPart).replace('-', '');
    const negative = num < 0 ? '-' : '';

    let decimalPointIndex = integerPart.length + exp;

    // Limit decimal places to maxDecimals for very small numbers
    if (decimalPointIndex < -maxDecimals) {
      decimalPointIndex = -maxDecimals;
    }

    if (decimalPointIndex <= 0) {
      str = negative + '0.' + '0'.repeat(-decimalPointIndex) + digits;
    } else if (decimalPointIndex >= digits.length) {
      str = negative + digits + '0'.repeat(decimalPointIndex - digits.length);
    } else {
      str =
        negative +
        digits.slice(0, decimalPointIndex) +
        '.' +
        digits.slice(decimalPointIndex);
    }
  }

  // Trim unnecessary trailing zeros and decimal point
  str = str.replace(/\.?0+$/, '');

  return str;
};
